<template>
  <div :class="$style.wrapper">
    <Tablet width="66.6rem" height="97.5rem" profBottom="-3rem" profRight="-0.4rem" :class="$style.tablet">
      <div :class="$style.inner">
        <Transition mode="out-in">
          <dnd-list v-if="currentQuestion === 1 && currentQuestionData.type === 'dnd-list'" :currentQuestion="currentQuestion" @next="onNext"></dnd-list>
          <classic v-if="currentQuestion === 2 && currentQuestionData.type === 'classic'" :currentQuestion="currentQuestion" @next="onNext"></classic>
          <classic-multiple v-if="currentQuestion === 0 && currentQuestionData.type === 'classic-multiple'" :currentQuestion="currentQuestion" @next="onNext"></classic-multiple>
          <dndCompare v-if="currentQuestion === 3 && currentQuestionData.type === 'dnd-compare'" :currentQuestion="currentQuestion" @next="onNext"></dndCompare>
          <div v-if="currentQuestion >= questions.length">
            <p :class="$style.text">Молодец! Тест пройден успешно!</p>
            <v-btn @click="$emit('success')" :class="$style.btn">Завершить</v-btn>
          </div>
        </Transition>
      </div>
    </Tablet>
  </div>
</template>

<script>
import {
  ref, computed,
} from 'vue'

import Tablet from '../../../../components/@ui/tablet/Tablet.vue'
import dndList from './dnd-list/dndList.vue'
import classic from './classic/classic.vue'
import classicMultiple from './classicMultiple/classicMultiple.vue'
import dndCompare from './dnd-compare/dndCompare.vue'
import questions from './questions'

export default {
  name: 'trainerH4',
  emits: ['success'],
  components: {
    Tablet,
    dndList,
    classic,
    classicMultiple,
    dndCompare,
  },
  setup() {
    const currentQuestion = ref(0)

    const currentQuestionData = computed(() => questions[currentQuestion.value])

    const onNext = () => {
      if (questions[currentQuestion.value] !== undefined) {
        currentQuestion.value += 1
      }
      return false
    }

    return {
      questions,
      currentQuestion,
      currentQuestionData,
      onNext,
    }
  },
}
</script>

<style lang="scss">
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>

<style lang="scss" module src="./trainerH4.scss"></style>
